<div class="pb-5">
  <div class="container">
    @if (!isAuthenticated) {
    <app-placeholder title="EMPTY_STATE.ANONYMOUS_PARKING_TICKETS_TITLE" subTitle="EMPTY_STATE.ANONYMOUS_PARKING_TICKETS_DESCRIPTION"
      icon="assets/icons/empty-state/NO_SUBSCRIPTIONS_YET.svg" buttonLabel="GENERAL.LOGIN"
      (action)="navigateToLogin()">
    </app-placeholder>
    } @else {

    <!-- Page header -->
    <div class="row mb-4">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <h1 class="page-title mb-0">{{ 'HOME.PARKING_TICKETS' | translate }}</h1>
        <app-button [label]="'HOME.PARKING_TICKETS_BTN' | translate" [color]="'outline-primary'"
          (click)="openAddTicketDialog()">
        </app-button>
      </div>
    </div>

    <!-- Loading skeletons -->
    @if (isLoading) {
    <div class="row g-3">
      @for (_ of [1, 2, 3, 4, 5, 6]; track $index) {
      <div class="col-12 col-md-6 col-lg-4">
        <p-skeleton width="100%" height="14rem" borderRadius="1rem" />
      </div>
      }
    </div>
    } @else {

    <!-- Empty state -->
    @if (!tickets || tickets.length === 0) {
    <app-placeholder title="HOME.PARKING_TICKETS_TITLE" subTitle="HOME.PARKING_TICKETS_DESC"
      icon="assets/images/mobile-scanning.svg" buttonLabel="HOME.PARKING_TICKETS_BTN" (action)="openAddTicketDialog()">
    </app-placeholder>
    } @else {

    <!-- Ticket cards grid -->
    <div class="row g-3">
      @for (ticket of tickets; track ticket.id) {
      <div class="col-12 col-md-6 col-lg-4">
        <app-parking-ticket-card [ticket]="ticket"></app-parking-ticket-card>
      </div>
      }
    </div>

    <!-- Pagination -->
    <app-pagination [page]="page" [pageSize]="pageSize" [totalRecords]="totalRecords" [pageSizeOptions]="pageSizesPagination"
      (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" />

    }
    }
    }
  </div>

</div>
